import { BasicRequest } from "./basicRequest";

export class SFTPUserChangePasswordRequest extends BasicRequest{

    public sftpUserId! : number;
    public newPwd! : string;

    constructor(){
        super()
    }
}